import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/awareness-session/page.tsx");
